<template>
  <v-app class="bckgrnd">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
            <v-flex xs1 sm1 md1 style="padding-top:25px;text-align:center">
                <v-icon color="green" size="25px" @click="leadBtn()">add_circle</v-icon>
          </v-flex>
          <v-flex xs7 sm7 md7 style="padding-right:5px">
            <v-autocomplete
                              dense
                              v-model="selectedLead"
                              :items="lead"
                              label="Select Lead *"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm12 md4>
              <v-dialog ref="dialog" v-model="dateModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="form.admissionDate"
                                label="Admission Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="form.admissionDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>

          <v-flex xs12 sm12 md4 style="padding-right:5px" v-if="selectedLead != null">
              <v-text-field disabled v-model="selectedLead.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 style="padding-right:5px" v-if="selectedLead != null">
              <v-text-field disabled v-model="selectedLead.mobileNumber" label="Mobile Number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 v-if="selectedLead != null">
              <v-text-field disabled v-model="selectedLead.levelName" label="Level"></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="selectedLead != null">
              <v-text-field v-model="form.guardianName" label="Guardian Name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="selectedLead != null">
              <v-text-field type="Number" v-model="form.guardianNo" label="Guardian Number *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="selectedLead != null">
              <v-text-field v-model="form.guardianEmail" label="Guardian Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 v-if="selectedLead != null">
              <v-text-field v-model="form.relation" label="Relation *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 v-if="selectedLead != null">
              <v-toolbar flat color="transparent">
                  <h5 class="grey--text">Training Type Selection(s)</h5>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog1" max-width="800px" persistent>
                  <v-btn small color="primary" flat outline slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-form ref="form1" v-model="valid" lazy-validation>
                              <v-layout wrap row>
                                  <v-flex xs12>
                                      <v-autocomplete
                              dense
                              v-model="selectedType"
                              :items="type"
                              label="Select Training Type"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                                      <v-text-field type="Number" v-model="form1.fee" label="Fee *" :rules="emptyRule" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                                      <v-text-field type="Number" v-model="form1.classNo" label="No. of Classes *" :rules="emptyRule" required></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm12 md4>
                                      <v-autocomplete
                              dense
                              v-model="selectedMode"
                              :items="mode"
                              label="Select Training Mode"
                              item-text="mode"
                              item-value="mode"
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12>
                                      <v-autocomplete
                              dense
                              v-model="selectedTeacher"
                              :items="teacher"
                              label="Select Teacher"
                              item-text="fullName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>
                              </v-layout>
                              </v-form>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
              </v-toolbar>

              <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.fee }}</td>
                <td class="text-xs-left">{{ props.item.classNo }}</td>
                <td class="text-xs-left">{{ props.item.mode }}</td>
                <td class="text-xs-left">{{ props.item.fullName }}</td>
                <td class="justify-center">
                  <v-icon color="error" class="ml-3" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
            <v-btn depressed color="orange" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Training",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dateModel: false,
      dialog: false,
      dialog1: false,

      headers: [
        { text: "#", value: "#" },
        { text: "Training Type", value: "name" },
        { text: "Fee", value: "fee" },
        { text: "No. of Class", value: "classNo" },
        { text: "Mode", value: "mode" },
        { text: "Teacher", value: "fullName" },
        { text: "Remove", value: "remove" }
      ],


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required."
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Training",
          disabled: false,
          to: "/training"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createTraining"
        }
      ],
      roleTypes: null,
      selectedRoleType: null,

      lead: null,
      selectedLead: null,

      type: null,
      selectedType: null,

      teacher: null,
      selectedTeacher: null,

      mode: ["Online", "Offline"],
      selectedMode: "Offline",

      itemAdded: [],

      form1: {
          fee: null,
          classNo: null
      },

      form: {
        guardianName: null,
        guardianNo: null,
        relation: null,
        guardianEmail: null,
        admissionDate: new Date().toISOString().substr(0, 10)
      }
    };
  },

  mounted() {
      this.axios
        .get(config.API + "Teachers", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.teacher = res.data;
          this.$Progress.finish();
        });

        this.getLead();
        this.getType();
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    leadBtn() {
        this.$router.push(`/createLead`);
    },

    getLead() {
        this.axios
        .get(config.API + "LeadSelection", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.lead = res.data;
          this.$Progress.finish();
          this.getLead();
        });
    },

    getType() {
        this.axios
        .get(config.API + "TrainingTypes", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.type = res.data;
          this.$Progress.finish();
          this.getType();
        });
    },

    close() {
      this.dialog1 = false;
      this.$refs.form1.reset();
    },
    deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
         const index = this.itemAdded.indexOf(item);
         this.itemAdded.splice(index, 1);
      }
    },

    save() {
        /* if (this.$refs.form1.validate()) { */
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
               typeId: JSON.parse(this.selectedType.id),
               name: this.selectedType.name,
               fee: JSON.parse(this.form1.fee),
               classNo: JSON.parse(this.form1.classNo),
               mode: this.selectedMode,
               teacherId: this.selectedTeacher.id,
               fullName: this.selectedTeacher.fullName
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _typeId = this.itemAdded[i].typeId;

                    if(_typeId == this.selectedType.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
               typeId: JSON.parse(this.selectedType.id),
               name: this.selectedType.name,
               fee: JSON.parse(this.form1.fee),
               classNo: JSON.parse(this.form1.classNo),
               mode: this.selectedMode,
               teacherId: this.selectedTeacher.id,
               fullName: this.selectedTeacher.fullName
              });

              this.close();
               }
            }
        //}
    },

    onSubmit() {
        /* console.log({
            leadId: JSON.parse(this.selectedLead.id),
              admissionDate: this.form.admissionDate,
              guardianName: this.form.guardianName,
              guardianNo: JSON.parse(this.form.guardianNo),
              guardianEmail: this.form.guardianEmail,
              relation: this.form.relation,

              trainingDetails: this.itemAdded
        }); */
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Trainings`,
            {
              leadId: JSON.parse(this.selectedLead.id),
              studentName: this.selectedLead.name,
              studentNo: JSON.parse(this.selectedLead.mobileNumber),
              admissionDate: this.form.admissionDate,
              guardianName: this.form.guardianName,
              guardianNo: JSON.parse(this.form.guardianNo),
              guardianEmail: this.form.guardianEmail,
              relation: this.form.relation,

              trainingDetails: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Training successfully created");
            this.$router.push(`imageUpload/${this.selectedLead.id}`);
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
